import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable, produce } from 'immer';
import { OrderedSet } from 'immutable';

interface IOrphanProjectItemEntity {
	id: number;
	label: string;
	tags: OrderedSet<AppTagItemEntity>;
	adminId?: string;
}

const entityDefaults: IOrphanProjectItemEntity = {
	id: -1,
	label: '',
	tags: OrderedSet(),
	adminId: undefined,
};

export class OrphanProjectItemEntity implements IOrphanProjectItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public tags = entityDefaults.tags;
	public adminId = entityDefaults.adminId;

	public static build(
		params: Partial<IOrphanProjectItemEntity> = {}
	): OrphanProjectItemEntity {
		const entity = new OrphanProjectItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.label = params.label ?? entityDefaults.label;
		entity.tags = params.tags ?? entityDefaults.tags;
		return entity;
	}

	public setAdmin(id: string): OrphanProjectItemEntity {
		return produce(this, (draft: OrphanProjectItemEntity) => {
			draft.adminId = id;
		});
	}
}
